// This file is automatically generated by scripts/refresh-assets.ts.
// Do not edit manually. Or do, I'm a comment, not a cop.

export const version = '2.4.4'
export const publishDates = {
	major: '2024-06-28T10:56:07.893Z',
	minor: '2024-07-22T16:42:50.301Z',
	patch: '2024-08-05T17:56:04.722Z',
}
